import Vue from 'vue';
import Axios, { CancelTokenSource } from 'axios';

const CancelTokenMixin = Vue.extend({
    methods: {
        createCancelToken(key: string) {
            this.cancelIfPending(key);
            this.cancelTokens[key] = Axios.CancelToken.source();

            return this.cancelTokens[key].token;
        },
        cancelIfPending(key: string) {
            if (this.cancelTokens[key] && this.cancelTokens[key].cancel) {
                this.cancelTokens[key].cancel();

                delete this.cancelTokens[key];
            }
        },
        throwIfNotCancel(e: any) {
            if (!Axios.isCancel(e)) {
                throw e;
            }
        }
    },
    data() {
        return {
            cancelTokens: {} as { [tokenName: string]: CancelTokenSource },
        };
    }
});

export default CancelTokenMixin;
